<script>
import {getDownloadURL} from '../../helper/ImageCache';

let gsReference = null;
let filePath = '';
let className = '';

export {filePath as src};
export {className as class};

export let isExternal = false;

function onChange(){
    if(filePath == gsReference)
        return;
    if(isExternal){
        gsReference = filePath;
    }
    else{
        getDownloadURL(filePath).then((url)=>{
            gsReference = url;
        })
    }
}

$: filePath && onChange();



</script>
<img src="{gsReference}" alt="test" class="{className}" class:invisible={gsReference == null} />